export default "__VITE_ASSET__juGoq71A__"